import * as d3 from "d3";

class Color {

  constructor(hex) {
    this.hex = hex;
    this.vector = this.toVector(hex);
  }

  toVector(color = this.hex) {
    const rgb = d3.rgb(color);
    return [rgb.r / 255, rgb.g / 255, rgb.b / 255];
  }

  variedVector(color = this.hex) {
    let hsl = d3.hsl(color);
    hsl.l *= 0.2 + Math.min(Math.random(), 0.5);
    return this.toVector(hsl);
  }

}

export default {
  dark:   new Color('#020203'),
  grey:   new Color('#9797ba'),
  light:  new Color('#F0F0F0'),
  blue:   new Color('#4dd2ff'),
  green:  new Color('#23ff85'),
  yellow: new Color('#fede7c'),
  orange: new Color('#ffcca2'),
  red:    new Color('#fc4e4e'),
  pink:   new Color('#FF4DD2'),
  purple: new Color('#e699ff'),
  // blue:   new Color('#00BFFF'),
  // green:  new Color('#3CB371'),
  // yellow: new Color('#F2D26F'),
  // red:    new Color('#ED1111'),
};



// WEBPACK FOOTER //
// ./src/helpers/colors.js